import { spec } from "shared";
import { run } from "features/engine/engine";

export const app = run(spec);
